// Integração Cart Drawer com Yampi Checkout
(function() {
  'use strict';

  const cartEndpoint = 'https://api.dooki.com.br/v2/public/shopify/cart';
  const shopifyInternalUrl = window.Shopify?.shop || '';

  function showYampiLoader() {
    const loader = document.querySelector('.yampi-loader');
    if (loader) {
      loader.style.display = 'block';
    }
  }

  function hideYampiLoader() {
    const loader = document.querySelector('.yampi-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  function getUrlWithUtms(url) {
    if (!url) return url;

    try {
      const currentUrl = new URL(url);
      const _ga = getCookie('_ga');
      const cookiesUtms = getUtms();

      cookiesUtms.forEach((value, key) => {
        currentUrl.searchParams.set(key, value);
      });

      if (_ga) {
        currentUrl.searchParams.set('_ga', _ga);
      }

      return currentUrl.href;
    } catch (e) {
      return url;
    }
  }

  function getUtms() {
    const currentUtms = getCookie('utmsTrack');
    if (currentUtms) {
      return new URLSearchParams(currentUtms);
    }
    return new URLSearchParams();
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  async function redirectToYampiCheckout() {
    showYampiLoader();

    try {
      // Pega o carrinho atual
      const cartResponse = await fetch('/cart.json');
      const cartPayload = await cartResponse.json();

      // Envia para a API da Yampi
      const data = {
        shop: window.location.host,
        shopify_internal_domain: shopifyInternalUrl,
        cart_payload: cartPayload
      };

      const yampiResponse = await fetch(cartEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      });

      const yampiData = await yampiResponse.json();

      if (yampiData.checkout_direct_url) {
        // Redireciona para o checkout da Yampi
        window.location.href = getUrlWithUtms(yampiData.checkout_direct_url);
      } else {
        // Fallback para o carrinho
        hideYampiLoader();
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('Erro ao redirecionar para checkout Yampi:', error);
      hideYampiLoader();
      // Fallback para o checkout padrão
      window.location.href = '/checkout';
    }
  }

  function interceptCartDrawerCheckout() {
    // Função para interceptar o botão
    const interceptButton = () => {
      const checkoutButton = document.querySelector('#CartDrawer-Checkout, .cart__checkout-button');
      
      if (checkoutButton && !checkoutButton.dataset.yampiIntegrated) {
        console.log('✓ Cart Drawer checkout button found');
        checkoutButton.dataset.yampiIntegrated = 'true';
        
        // Remove o evento original clonando o botão
        const newButton = checkoutButton.cloneNode(true);
        checkoutButton.parentNode.replaceChild(newButton, checkoutButton);
        
        // Adiciona o novo listener para a Yampi
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          console.log('✓ Redirecting to Yampi checkout from cart drawer');
          redirectToYampiCheckout();
          
          return false;
        }, true);
        
        console.log('✓ Cart Drawer checkout button intercepted for Yampi');
      }
    };

    // Verifica imediatamente
    interceptButton();

    // Observa mudanças no DOM (cart drawer é carregado dinamicamente)
    const observer = new MutationObserver(() => {
      interceptButton();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Verifica periodicamente nos primeiros segundos
    let checks = 0;
    const interval = setInterval(() => {
      interceptButton();
      checks++;
      if (checks >= 15) clearInterval(interval);
    }, 500);
  }

  // Listener global como fallback
  document.addEventListener('click', (e) => {
    const target = e.target;
    
    // Verifica se é o botão de checkout do cart drawer
    if (target.matches('#CartDrawer-Checkout, .cart__checkout-button') || 
        target.closest('#CartDrawer-Checkout, .cart__checkout-button')) {
      
      // Verifica se está dentro do cart drawer
      const isInCartDrawer = target.closest('cart-drawer, .cart-drawer');
      
      if (isInCartDrawer) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        console.log('✓ Global fallback: Redirecting to Yampi checkout');
        redirectToYampiCheckout();
        
        return false;
      }
    }
  }, true);

  // Inicia a interceptação quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptCartDrawerCheckout);
  } else {
    interceptCartDrawerCheckout();
  }
})();

